import { InvoiceStatus } from "@prisma/client";

/** Posted (GL-impacting) invoice statuses — mirrors `isInvoicePosted` in order-actions-text. */
export const postedInvoiceStatuses: InvoiceStatus[] = [InvoiceStatus.POSTED, InvoiceStatus.PARTIALLY_PAID, InvoiceStatus.PAID];

/** Capability rollout changes presentation only; canonical persistence is always on. */
export function displayedOrderInvoiceStatuses<T extends string>(statuses: readonly T[], advancedEnabled: boolean): T[] {
  return advancedEnabled ? [...new Set(statuses)] : statuses.slice(0, 1);
}

export function visibleOrderBillingAccessors<T extends string>(accessors: readonly T[], advancedEnabled: boolean): T[] {
  return accessors.filter(accessor => advancedEnabled || accessor !== "remainingBillableAmount");
}
